import { Component, OnInit } from '@angular/core';
import { formatDate, UpperCasePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';

import { DnChargeService, AuthenticationService, NotificationService, KeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dn-charge',
  templateUrl: './dn-charge.component.html'
})
export class DnChargeComponent implements OnInit {
  reportsWrappr: any = null;
  sourceList = [];
  countryList: any = {};
  operatorList = [];
  loading = false;
  processing = false;
  emptyResult = true;
  exporting = false;
  downloadUrl = '';
  //filter
  filterable = {
    source: null,
    country: null,
    operator: "",
    day: null,
    realtime: false,
  };

  realtimeFlags = {'Realtime': true, 'Offline': false};
  resultName = '';

  selectedCountry = '';
  active = 1;
  resultParams = {};

  redRowCheckbox = true;
  greenRowCheckbox = true;
  otherRowCheckbox = true;

  constructor(private fb: FormBuilder,
    private authSvc: AuthenticationService,
    private keywordSvc: KeywordService,
    private dnChargeSvc: DnChargeService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.day = dte.toISOString().substring(0, 10);
    this.loadSources();
    // this.loadShortCodes();
    // this.search();
  }

  isDisplay(diffRate){
    if(diffRate >= 5){
      return this.redRowCheckbox;
    }else if(diffRate >= 1){
      return this.greenRowCheckbox;
    }else{
      return this.otherRowCheckbox;
    }
  }

  search() {
    this.redRowCheckbox = true;
    this.greenRowCheckbox = true;
    this.otherRowCheckbox = true;
    var day = formatDate(this.filterable.day, 'yyyyMMdd', 'en');
    this.loadPage(day);
  }

  export() {
    this.exporting = true;
    var day = formatDate(this.filterable.day, 'yyyyMMdd', 'en');
    let params = {
      day: day,
      source: this.filterable.source.value,
      country: this.filterable.country,
      operator: this.filterable.operator
    }
    this.dnChargeSvc.export(params, this.filterable.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  changeSource(source) {
    if (source) {
      this.countryList = source.subOptions;
      var key = Object.keys(this.countryList)[0];
      var value = this.countryList[key];
      this.selectedCountry = value;
      this.filterable.country = value;
      this.changeCountry(value);
    }
  }

  changeCountry(country) {
    this.filterable.operator = '';
    this.filterable.country = country;
    this.selectedCountry = country;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country).subscribe(data => {
        this.operatorList = Object.keys(data.data);
      });
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      let currentSource = this.sourceList.find(it => it.name == 'PAY365');
      if(!currentSource){
        currentSource = data.data[0];
      }
      this.filterable.source = currentSource;
      this.countryList = currentSource.subOptions;
      var key = Object.keys(currentSource.subOptions)[0];
      var value = currentSource.subOptions[key];
      let tempObj = {
        key: key,
        value: value
      };
      this.selectedCountry = value;
      this.filterable.country = value;
      this.changeCountry(this.filterable.country);
    });
  }

  private loadPage(date) {
    this.emptyResult = true;
    this.loading = true;
    this.reportsWrappr = null;
    let params = {
      day: date,
      source: this.filterable.source.value,
      country: this.filterable.country,
      operator: this.filterable.operator,
      realtime: this.filterable.realtime,
    }
    this.resultParams = params;
    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';
    // get page of items from api
    this.dnChargeSvc.getAll(params, this.filterable.realtime).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.reportsWrappr = data.data;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for this DN Charge.", "Empty Result");
      }
    });
  }

}
